{
  "REPORT": {
    "HEADER": "Conversas",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_AGENT_REPORTS": "Descarregar relatórios de agentes",
    "DATA_FETCHING_FAILED": "Não foi possível obter dados. Por favor, tente mais tarde.",
    "SUMMARY_FETCHING_FAILED": "Não foi possível obter o resumo. Por favor, tente mais tarde.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens enviadas",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Contagem de transferências",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Tempo de espera do cliente",
        "TOOLTIP_TEXT": "O tempo de espera é {metricValue} (com base em {conversationCount} conversas)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Hoje",
      "YESTERDAY": "Ontem",
      "LAST_7_DAYS": "Últimos 7 Dias",
      "LAST_30_DAYS": "Últimos 30 Dias",
      "THIS_MONTH": "Este mês",
      "LAST_MONTH": "Mês passado",
      "LAST_3_MONTHS": "Últimos 3 meses",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último ano",
      "CUSTOM_DATE_RANGE": "Intervalo de tempo personalizado"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Agrupar por",
    "DURATION_FILTER_LABEL": "Duração",
    "GROUPING_OPTIONS": {
      "DAY": "Dia",
      "WEEK": "Semana",
      "MONTH": "Mês",
      "YEAR": "Ano"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dia"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mês"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mês"
      },
      {
        "id": 4,
        "groupBy": "Ano"
      }
    ],
    "BUSINESS_HOURS": "Horário comercial",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Limpar filtros",
      "EMPTY_LIST": "Nenhum resultado encontrado"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Conversas: {count}",
      "RESULT_COUNT_MESSAGE": "Mensagens: {count}",
      "EMPTY": "Nenhum registo encontrado para esta barra.",
      "ERROR": "Não foi possível carregar os registos. Tente novamente.",
      "LOAD_MORE": "Carregar mais",
      "PREVIOUS_BUCKET": "Barra anterior",
      "NEXT_BUCKET": "Barra seguinte",
      "UNKNOWN_CONTACT": "Contacto desconhecido",
      "UNKNOWN_INBOX": "Caixa de entrada desconhecida",
      "UNASSIGNED_AGENT": "Não atribuída",
      "NO_MESSAGE_CONTENT": "Mensagem sem conteúdo",
      "MESSAGE_CREATED_AT": "Mensagem criada em {time}",
      "EVENT_OCCURRED_AT": "Evento ocorrido em {time}",
      "INCOMING_MESSAGE": "Mensagem recebida",
      "OUTGOING_MESSAGE": "Mensagem enviada",
      "VIEW_ALL": "Ver nas conversas",
      "VIEW_ALL_LIMIT": "Apenas as barras com até {limit} conversas abrem na lista de conversas.",
      "HIDDEN_COUNT": "Não mostradas porque não é membro da respetiva caixa de entrada: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Visão geral de agentes",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_AGENT_REPORTS": "Descarregar relatórios de agentes",
    "FILTER_DROPDOWN_LABEL": "Selecionar agente",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Visão geral de etiquetas",
    "DESCRIPTION": "Acompanhe o desempenho das etiquetas com métricas-chave, incluindo conversas, tempos de resposta, tempos de resolução e casos resolvidos.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_LABEL_REPORTS": "Descarregar relatórios de etiquetas",
    "FILTER_DROPDOWN_LABEL": "Selecionar etiqueta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Visão geral da caixa de entrada",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_INBOX_REPORTS": "Descarregar relatórios de caixa de entrada",
    "FILTER_DROPDOWN_LABEL": "Escolher caixa de entrada",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Visão geral da equipa",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "A carregar dados...",
    "NO_ENOUGH_DATA": "Não recebemos pontos de dados suficientes para gerar o relatório. Por favor, tente novamente mais tarde.",
    "DOWNLOAD_TEAM_REPORTS": "Descarregar relatórios de equipa",
    "FILTER_DROPDOWN_LABEL": "Selecionar equipa",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversas",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensagens recebidas",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensagens de saída",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primeiro tempo de resposta",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo de resolução",
        "DESC": "( Média )",
        "INFO_TEXT": "Número total de conversas utilizadas para cálculo:",
        "TOOLTIP_TEXT": "O tempo da primeira resposta é {metricValue} (com base em {conversationCount} conversas)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Contagem de resolução",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 Dias"
      },
      {
        "id": 1,
        "name": "Últimos 30 Dias"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último ano"
      },
      {
        "id": 5,
        "name": "Intervalo de tempo personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Confirmar",
      "PLACEHOLDER": "Selecionar intervalo de tempo"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Relatórios CSAT",
    "NO_RECORDS": "Não há respostas de questionários CSAT disponíveis.",
    "DOWNLOAD": "Descarregar relatórios CSAT",
    "DOWNLOAD_FAILED": "Falha ao descarregar os relatórios CSAT",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Escolher agentes"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contacto",
        "AGENT_NAME": "Agente atribuído",
        "RATING": "Classificação",
        "FEEDBACK_TEXT": "Comentário de feedback"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respostas",
        "TOOLTIP": "Número total de respostas recolhidas"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Pontuação de satisfação",
        "TOOLTIP": "Número total de respostas positivas / Número total de respostas * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Taxa de resposta",
        "TOOLTIP": "Número total de respostas / Número total de mensagens de questionários CSAT enviadas * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Relatórios de bot",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Número de conversas",
        "TOOLTIP": "Número total de conversas com mensagens do bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Número de respostas",
        "TOOLTIP": "Número total de mensagens enviadas"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Número de respostas de IA",
        "TOOLTIP": "Número total de mensagens de resposta enviadas pelo bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Número de respostas preparadas",
        "TOOLTIP": "Número total de sugestões do copiloto preparadas pelo bot para os agentes"
      },
      "SUCCESS_RATE": {
        "LABEL": "Resolvidas por IA",
        "TOOLTIP": "Percentagem de conversas resolvidas por IA sem transferência para um agente"
      },
      "RESOLVE_TIME": {
        "LABEL": "Tempo de resolução",
        "TOOLTIP": "Tempo médio entre a primeira mensagem do cliente e a última mensagem do bot/agente"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "N.º de conversas",
        "TOOLTIP": "Número total de conversas tratadas pelo bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respostas",
        "TOOLTIP": "Número total de respostas enviadas pelo bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Taxa de resolução",
        "TOOLTIP": "Número total de conversas resolvidas pelo bot / Número total de conversas tratadas pelo bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Taxa de transferência",
        "TOOLTIP": "Número total de conversas transferidas para agentes / Número total de conversas tratadas pelo bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Não agrupar",
      "INBOXES": "Caixas de entrada",
      "LABELS": "Etiquetas"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribuição por grupo",
      "BACK_TO_ALL": "Mostrar tudo",
      "TABLE": {
        "INBOX": "Caixa de entrada",
        "LABEL": "Etiqueta",
        "CONVERSATIONS": "Conversas",
        "MESSAGES": "Mensagens",
        "MESSAGES_TOOLTIP": "Número total de mensagens enviadas",
        "AI_MESSAGES": "Respostas de IA",
        "AI_MESSAGES_TOOLTIP": "Número total de respostas de IA, seguido do número de avaliações positivas e negativas dos utilizadores finais",
        "THUMBS_UP_TOOLTIP": "Número de respostas de IA avaliadas positivamente (polegar para cima) pelos utilizadores finais",
        "THUMBS_DOWN_TOOLTIP": "Número de respostas de IA avaliadas negativamente (polegar para baixo) pelos utilizadores finais",
        "PREPARED": "Respostas preparadas",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Percentagem de mensagens deste grupo em relação a todas as mensagens",
        "BOT_RESPONSES": "% de respostas de IA",
        "SUGGESTION_USED": "Respostas utilizadas",
        "SUGGESTION_USED_TOOLTIP": "Percentagem de respostas preparadas deste grupo que foram utilizadas pelos agentes",
        "SUGGESTION_NOT_USED": "Respostas não utilizadas",
        "SUGGESTION_NOT_USED_TOOLTIP": "Percentagem de mensagens deste grupo que tinham uma resposta preparada mas não foi utilizada"
      },
      "NOTES": {
        "TITLE": "Como as métricas são calculadas",
        "CONVERSATIONS": "Número de conversas que têm pelo menos uma mensagem enviada no período selecionado.",
        "MESSAGES": "Número total de mensagens enviadas (não privadas) no período selecionado. Inclui mensagens geradas por IA e escritas por humanos.",
        "PERCENTAGE": "Proporção das mensagens deste grupo em relação a todas as mensagens enviadas em todos os grupos.",
        "AI_MESSAGES": "Número de mensagens enviadas automaticamente pelo bot de IA (sem incluir as respostas preparadas para os agentes). Os números entre parênteses mostram quantas dessas respostas foram avaliadas positivamente (polegar para cima) e negativamente (polegar para baixo) pelos utilizadores finais.",
        "PREPARED": "Número de sugestões do copiloto (respostas preparadas) geradas pelo bot de IA para os agentes no período selecionado. São mensagens privadas, visíveis apenas para os agentes, e não são contadas como mensagens enviadas, pelo que este número pode não corresponder à coluna Mensagens.",
        "SUGGESTION_USED": "Percentagem de respostas preparadas deste grupo que foram utilizadas pelos agentes. Pode não corresponder ao número de Respostas preparadas, porque também pode incluir sugestões geradas em períodos anteriores.",
        "SUGGESTION_NOT_USED": "Percentagem de mensagens enviadas deste grupo em que existia uma sugestão do copiloto disponível, mas o agente respondeu sem a utilizar. Só é contabilizado quando o agente envia efetivamente uma resposta. Pode não corresponder ao número de Respostas preparadas, porque também pode incluir sugestões geradas em períodos anteriores."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Visão geral",
    "LIVE": "Disponível",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Conversas abertas",
      "LOADING_MESSAGE": "A carregar métricas de conversa...",
      "OPEN": "Abertas",
      "UNATTENDED": "Por responder",
      "UNASSIGNED": "Não atribuída",
      "PENDING": "Pendente"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Tráfego de conversa",
      "NO_CONVERSATIONS": "Não existem conversas",
      "CONVERSATION": "{count} conversa",
      "CONVERSATIONS": "{count} conversas",
      "DOWNLOAD_REPORT": "Descarregar relatório"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversas por agentes",
      "LOADING_MESSAGE": "A gerar métricas dos agentes...",
      "NO_AGENTS": "Não existem conversas por agentes",
      "TABLE_HEADER": {
        "AGENT": "Agente",
        "OPEN": "Abertas",
        "UNATTENDED": "Por responder",
        "STATUS": "Estado"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Equipa",
        "OPEN": "Abertas",
        "UNATTENDED": "Por responder",
        "STATUS": "Situação"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Estado do agente",
      "ONLINE": "Disponível",
      "BUSY": "Ocupado",
      "OFFLINE": "Ausente"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Domingo",
    "MONDAY": "Segunda-feira",
    "TUESDAY": "Terça-feira",
    "WEDNESDAY": "Quarta-feira",
    "THURSDAY": "Quinta-feira",
    "FRIDAY": "Sexta-feira",
    "SATURDAY": "Sábado"
  },
  "SLA_REPORTS": {
    "HEADER": "Relatórios SLA",
    "NO_RECORDS": "Conversas com SLA aplicadas não estão disponíveis.",
    "LOADING": "A carregar dados SLA...",
    "DOWNLOAD_SLA_REPORTS": "Descarregar relatórios SLA",
    "DOWNLOAD_FAILED": "Falha ao efetuar download dos relatórios SLA",
    "DROPDOWN": {
      "ADD_FIlTER": "Adicionar filtro",
      "CLEAR_ALL": "Limpar tudo",
      "CLEAR_FILTER": "Limpar filtros",
      "EMPTY_LIST": "Nenhum resultado encontrado",
      "NO_FILTER": "Sem filtros disponíveis",
      "SEARCH": "Procurar filtros",
      "INPUT_PLACEHOLDER": {
        "SLA": "Nome SLA",
        "AGENTS": "Nome do agente",
        "INBOXES": "Nome da caixa de entrada",
        "LABELS": "Nome da etiqueta",
        "TEAMS": "Nome da equipa"
      },
      "SLA": "Política SLA",
      "INBOXES": "Caixa de entrada",
      "AGENTS": "Agente",
      "LABELS": "Etiqueta",
      "TEAMS": "Equipa"
    },
    "WITH": "com",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Taxa de sucesso",
        "TOOLTIP": "Percentagem de SLA criadas foi completada com sucesso"
      },
      "NO_OF_MISSES": {
        "LABEL": "Número de perdas",
        "TOOLTIP": "Total de SLA perdidas num determinado período"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Número de conversas",
        "TOOLTIP": "Número total de conversas com SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Política",
        "CONVERSATION": "Conversa",
        "AGENT": "Agente"
      },
      "VIEW_DETAILS": "Ver detalhes"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotal",
    "NO_TEAM": "Sem equipa",
    "GROUP_BY_TEAMS": "Agrupar por equipas",
    "INBOX": "Caixa de entrada",
    "AGENT": "Agente",
    "TEAM": "Equipa",
    "LABEL": "Etiqueta",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Contagem de resolução",
    "CONVERSATIONS": "Num de conversas",
    "OUTGOING_CHATS": "Chats enviados",
    "OUTGOING_EMAILS": "E-mails enviados",
    "PHONE_CALLS": "Chamadas telefónicas",
    "INBOUND_CALLS": "Chamadas recebidas",
    "OUTBOUND_CALLS": "Chamadas efetuadas",
    "TOTAL_ACTIVITIES": "Total de atividades",
    "ONLINE_TIME": "Tempo online",
    "QUEUE_AVAILABLE_TIME": "Tempo disponível na fila",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Número de mensagens enviadas por este agente",
      "OUTGOING_EMAILS": "Número de e-mails enviados por este agente",
      "PHONE_CALLS": "Número total de chamadas telefónicas atribuídas a este agente (soma das chamadas recebidas e efetuadas)",
      "TOTAL_ACTIVITIES": "Número total de atividades: chamadas recebidas + chamadas efetuadas + chats enviados + e-mails enviados",
      "INBOUND_CALLS": "Número de chamadas telefónicas recebidas atribuídas a este agente",
      "OUTBOUND_CALLS": "Número de chamadas telefónicas efetuadas atribuídas a este agente",
      "AVG_FIRST_RESPONSE_TIME": "Tempo médio entre a criação da conversa e a primeira resposta do agente, nas conversas atribuídas a este agente",
      "AVG_RESOLUTION_TIME": "Tempo médio entre a criação da conversa e a sua resolução, nas conversas atribuídas a este agente",
      "AVG_REPLY_TIME": "Tempo médio de espera dos clientes entre a sua mensagem e a resposta do agente, nas conversas atribuídas a este agente",
      "ONLINE_TIME": "Tempo total em que o agente esteve online ou ocupado durante o período selecionado",
      "QUEUE_AVAILABLE_TIME": "Tempo total em que o agente esteve disponível nas filas telefónicas durante o período selecionado"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Relatórios de telefone",
    "DESCRIPTION": "Acompanhe as métricas das chamadas telefónicas com informações detalhadas sobre chamadas recebidas e efetuadas, agrupadas por agente ou caixa de entrada para uma análise completa.",
    "DOWNLOAD_PHONE_REPORTS": "Transferir relatórios de telefone",
    "GROUP_BY": {
      "LABEL": "Agrupar por",
      "AGENT": "Agente",
      "INBOX": "Caixa de entrada"
    },
    "TABLE": {
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Recebidas",
      "OUTBOUND_CALLS": "Efetuadas",
      "FAILED_OUTBOUND_CALLS": "Efetuadas falhadas",
      "AVG_AGENT_HANDLED_DURATION": "Duração média",
      "TOTAL_AGENT_HANDLED_DURATION": "Duração total",
      "AVG_RINGING_TIME": "Tempo médio a tocar",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% de sucesso",
      "UNIQUE_CALLERS": "Chamadores únicos",
      "UNIQUE_CALLED_CONTACTS": "Contactos únicos ligados",
      "UNANSWERED_MISSED_CALLS": "Perdidas sem seguimento",
      "UNANSWERED_MISSED_PERCENTAGE": "% de perdidas sem resposta",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Perdidas sem seguimento, com retorno insuficiente",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% de perdidas sem seguimento, com retorno insuficiente"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Número total de todas as chamadas (incluindo as não atendidas)",
      "INBOUND_CALLS": "Número de chamadas atendidas",
      "OUTBOUND_CALLS": "Número de todas as chamadas efetuadas (incluindo as não atendidas)",
      "FAILED_OUTBOUND_CALLS": "Número de chamadas efetuadas que não foram atendidas",
      "AVG_AGENT_HANDLED_DURATION": "Duração média das chamadas atendidas pelos agentes",
      "TOTAL_AGENT_HANDLED_DURATION": "Duração total de todas as chamadas atendidas pelos agentes",
      "AVG_RINGING_TIME": "Tempo médio que as chamadas passam a tocar antes de serem atendidas",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentagem de chamadas efetuadas que foram atendidas com sucesso",
      "UNIQUE_CALLERS": "Número de contactos únicos que fizeram chamadas recebidas",
      "UNIQUE_CALLED_CONTACTS": "Número de contactos únicos que foram contactados através de chamadas efetuadas",
      "UNANSWERED_MISSED_CALLS": "Número de chamadas perdidas em que não foi feito um retorno com sucesso (chamada atendida). Pode incluir chamadas que ainda podem ser tratadas dentro do horário comercial",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentagem de chamadores únicos cujas chamadas ficaram perdidas sem seguimento (chamadas perdidas sem resposta / chamadores únicos)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Número de chamadas perdidas com menos de 2 tentativas de retorno. Pode incluir chamadas que ainda podem ser tratadas dentro do horário comercial",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentagem de chamadores únicos com menos de 2 tentativas de retorno ((perdidas sem seguimento - tratadas suficientemente) / chamadores únicos)"
    }
  }
}
